<template>
  <div class="pc-block-infos table-shadow">
    <div class="base-title">概况</div>
    <div class="info">
      <div class="left">
        <div class="item flex-left">
          <img src="../../../assets/img/common/red.png" />
          <label>全部数据</label>
          <span>{{ props.infos.txCount }}</span>
        </div>
        <div class="item flex-left">
          <img src="../../../assets/img/common/blue.png" />
          <label>默克尔根</label>
          <span>{{ filterHash(props.infos.txHash, 25) }}</span>
          <i
            class="iconfont iconfuzhi1 copy-txt"
            v-clipboard:copy="props.infos.txHash"
            v-clipboard:success="success"
            v-clipboard:error="error"
          ></i>
        </div>
        <div class="item flex-left">
          <img src="../../../assets/img/common/pink.png" />
          <label>父区块</label>
          <span
            class="light block-jump"
            @click="jump(props.infos.height - 1)"
            >{{
              props.infos.height - 1 >= 0 ? props.infos.height - 1 : "无"
            }}</span
          >
        </div>
      </div>
      <div class="right">
        <div class="item flex-left">
          <img src="../../../assets/img/common/red.png" />
          <label>时间（UTC + 8）</label>
          <span>{{ caculateTime(props.infos.blockTime) }}</span>
        </div>
        <div class="item flex-left">
          <img src="../../../assets/img/common/blue.png" />
          <label>状态哈希</label>
          <span>{{ filterHash(props.infos.stateHash, 25) }}</span>
          <i
            class="iconfont iconfuzhi1 copy-txt"
            v-clipboard:copy="props.infos.stateHash"
            v-clipboard:success="success"
            v-clipboard:error="error"
          ></i>
        </div>
        <div class="item flex-left">
          <img src="../../../assets/img/common/pink.png" />
          <label>子区块</label>
          <span
            class="light block-jump"
            @click="jump(Number(props.infos.height) + 1)"
            >{{
              maxHeight >= Number(props.infos.height) + 1
                ? Number(props.infos.height) + 1
                : "无"
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { caculateTime, filterHash } from "@/utils/filters";
import Store from "@/store/index";
import { useRouter } from "vue-router";
import { success, error } from "@/mixins/common";

const maxHeight = Store.state.maxHeight;
const router = useRouter();
const props = defineProps({
  infos: {
    txCount: 0,
    height: 0,
    txHash: "",
    blockTime: "",
    stateHash: "",
  },
});
function jump(height) {
  if (height < 0 || height > maxHeight) return;
  else
    router.push({
      path: "/blockdetail",
      query: { height: height },
    });
}
</script>

<style lang="scss" scoped>
.pc-block-infos {
  width: 100%;
  background: $white;
  border-radius: 5px;
  border: 1px solid rgba(235, 239, 241, 1);
  .base-title {
    height: 69px;
    line-height: 69px;
    padding-left: 30px;
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 500;
    color: $black;
    border-bottom: 1px solid #eee;
  }
  .info {
    font-size: 14px;
    color: $black;
    .left,
    .right {
      display: inline-block;
      width: 50%;
      padding: 20px 30px;
      .item {
        height: 55px;
        line-height: 55px;
        label {
          width: 130px;
          margin-left: 10px;
        }
      }
    }
    .left {
      border-right: 1px solid #ececec;
    }
    .block-jump {
      cursor: pointer;
    }
  }
}
</style>

